import { AccessToken } from '../access-token';
import { decodeJWTToken } from '../access-token/utils';
import { SSOService } from './SSOService';
import { zitadelSSOService } from './vendors/zitadel';

class CurrentSSOService {
  private ssoService: SSOService | null = null;

  public initializeSSOService() {
    const token = AccessToken.getToken();
    const tokenData = decodeJWTToken(token);

    this.ssoService = null;
    if (tokenData?.iss?.includes('zitadel')) {
      this.ssoService = zitadelSSOService;
    }
  }

  public setSSOService(ssoService: SSOService | null) {
    this.ssoService = ssoService;
  }

  public getSSOService(): SSOService | null {
    return this.ssoService;
  }
}

export const currentSSOService = new CurrentSSOService(); 